module.exports = __webpack_public_path__ + "img/user.49361fa6.svg";